import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MarathonRequests from "services/marathon";
import { fetchError } from "redux/actions";
import { makeStyles } from "@material-ui/core/styles";
import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import GridContainer from "@jumbo/components/GridContainer";
import MarathonQuestionElement from "./MarathonQuestion";
import QuestionFooter from "../compnents/QuestionFooter";
import AddQuesitonDialog from "../compnents/AddQuesitonDialog";
import RemoveQuesitonDialog from "../compnents/RemoveQuestionDialog";
import UpdateQuesitonDialog from "../compnents/UpdateQuestionDialog";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    marginTop: 10,
  },
  titleText: {
    fontSize: 20,
    fontWeight: "bold",
    color: theme.palette.primary.main,
    marginBottom: 16,
  },
  formControl: {
    width: "100%",
    marginInline: "auto",
    marginTop: 20,
  },
}));

function CreateMarathonQuestion({ question, eventId }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  
  // dialog states
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);

  // question states
  const [questionText, setQuestionText] = useState("");
  const [optionA, setOptionA] = useState("");
  const [optionB, setOptionB] = useState("");
  const [optionC, setOptionC] = useState("");
  const [optionD, setOptionD] = useState("");
  const [correctAnswer, setCorrectAnswer] = useState("");
  const [category, setCategory] = useState("");
  const [score, setScore] = useState(10);

  const setQuestion = () => {
    setQuestionText(question?.question || "");
    setOptionA(question?.optionA || "");
    setOptionB(question?.optionB || "");
    setOptionC(question?.optionC || "");
    setOptionD(question?.optionD || "");
    setCorrectAnswer(question?.correctAnswer || "");
    setCategory(question?.category || "");
    setScore(question?.score || 10);
  };

  useEffect(() => {
    if (question) {
      setQuestion();
    }
  }, [question]);

  const handleAddQuestion = () => {
    const questionData = {
      question: questionText,
      optionA: optionA,
      optionB: optionB,
      optionC: optionC,
      optionD: optionD,
      correctAnswer: correctAnswer,
      event: eventId,
      category: category,
      score: score,
    };

    if (
      !questionText ||
      !optionA ||
      !optionB ||
      !optionC ||
      !optionD ||
      !correctAnswer ||
      !category
    ) {
      dispatch(fetchError("وارد کردن تمامی موارد الزامی میباشد!!!"));
      setOpenAddDialog(false);
      return;
    }

    dispatch(MarathonRequests.addMarathonQuestion(questionData))
      .then(() => {
        resetState();
        setOpenAddDialog(false);
      })
      .catch((err) => {
        dispatch(fetchError(err));
        setOpenAddDialog(false);
      });
  };

  const handleEditAndClose = () => {
    const questionData = {
      question: questionText,
      optionA: optionA,
      optionB: optionB,
      optionC: optionC,
      optionD: optionD,
      correctAnswer: correctAnswer,
      event: eventId,
      category: category,
      score: score,
    };

    if (
      !questionText ||
      !optionA ||
      !optionB ||
      !optionC ||
      !optionD ||
      !correctAnswer ||
      !category
    ) {
      dispatch(fetchError("وارد کردن تمامی موارد الزامی میباشد!!!"));
      setOpenUpdateDialog(false);
      return;
    }

    dispatch(MarathonRequests.updateMarathonQuestion(question._id, questionData))
      .then(() => {
        setOpenUpdateDialog(false);
      })
      .catch((err) => {
        dispatch(fetchError(err));
        setOpenUpdateDialog(false);
      });
  };

  const handleRemoveAndClose = () => {
    dispatch(MarathonRequests.removeMarathonQuestion(question._id))
      .then(() => {
        setOpenRemoveDialog(false);
      })
      .catch((err) => {
        dispatch(fetchError(err));
        setOpenRemoveDialog(false);
      });
  };

  const resetState = () => {
    setQuestionText("");
    setOptionA("");
    setOptionB("");
    setOptionC("");
    setOptionD("");
    setCorrectAnswer("");
    setCategory("");
    setScore(10);
  };

  return (
    <React.Fragment>
      <div className={classes.cardContainer}>
        <CmtCard>
          <CmtCardContent>
            <GridContainer>
              <MarathonQuestionElement
                question={questionText}
                setQuestion={setQuestionText}
                optionA={optionA}
                setOptionA={setOptionA}
                optionB={optionB}
                setOptionB={setOptionB}
                optionC={optionC}
                setOptionC={setOptionC}
                optionD={optionD}
                setOptionD={setOptionD}
                correctAnswer={correctAnswer}
                setCorrectAnswer={setCorrectAnswer}
                category={category}
                setCategory={setCategory}
                score={score}
                setScore={setScore}
              />
            </GridContainer>
          </CmtCardContent>
          <QuestionFooter
            question={question}
            handleAdd={() => setOpenAddDialog(true)}
            handleRemove={() => setOpenRemoveDialog(true)}
            handleUpdate={() => setOpenUpdateDialog(true)}
          />
        </CmtCard>
      </div>
      <AddQuesitonDialog
        open={openAddDialog}
        handleClose={() => setOpenAddDialog(false)}
        action={handleAddQuestion}
      />
      <RemoveQuesitonDialog
        open={openRemoveDialog}
        handleClose={() => setOpenRemoveDialog(false)}
        action={handleRemoveAndClose}
      />
      <UpdateQuesitonDialog
        open={openUpdateDialog}
        handleClose={() => setOpenUpdateDialog(false)}
        action={handleEditAndClose}
      />
    </React.Fragment>
  );
}

export default CreateMarathonQuestion;
